import { useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { localStorageClient } from "../../storage/localStorageClient";
import { STORAGE_KEYS } from "../../storage/storageKeys";
import { getCurrentUser } from "@aws-amplify/auth";

export const AuthProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const [auth, setAuth] = useState(localStorageClient.get(STORAGE_KEYS.AUTH_KIND));

  const [userId, setUserId] = useState(localStorageClient.get(STORAGE_KEYS.USER_ID));

  const [identifyId, setIdentifyId] = useState(localStorageClient.get(STORAGE_KEYS.IDENTIFY_ID));

  const [roleId, setRoleId] = useState(localStorageClient.get(STORAGE_KEYS.ROLE_ID));
  /*
  課題・障害番号: IH-BUG-106
  対応日: 2026/03/24
  担当者: ユリヤ
  修正概要: ヘッダの企業クリニック名が表示されるのにタイムラグがある問題の修正
  */
  const [companyName, setCompanyName] = useState(localStorageClient.get(STORAGE_KEYS.COMPANY_NAME));

  const [kenpoName, setKenpoName] = useState(localStorageClient.get(STORAGE_KEYS.KENPO_NAME));
  /*
  END
  課題・障害番号: IH-BUG-106
  */

  // 初期ロード時にログイン状態確認
  useEffect(() => {
    const checkLogin = async () => {
      try {
        await getCurrentUser();
        setIsLogin(true);
      } catch {
        setIsLogin(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkLogin();
  }, []);

  /*
  課題・障害番号: KOSHO-77
  対応日: 2026/3/20
  担当者: 影山
  修正概要: Context内のログイン成功フラグを明示的に立てる処理（loginComplete）の追加
  */
  // ログイン処理成功時に明示的にフラグをオンにする
  const loginComplete = () => {
    setIsLogin(true);
  };
  /*
  END
  課題・障害番号: KOSHO-77
  */

  // 権限更新
  const updateAuth = (value) => {
    setAuth(value);

    if (value === null || value === undefined) {
      localStorageClient.remove(STORAGE_KEYS.AUTH_KIND);
    } else {
      localStorageClient.set(STORAGE_KEYS.AUTH_KIND, value);
    }
  };

  // ユーザーID更新
  const updateUserId = (value) => {
    setUserId(value);

    if (value === null || value === undefined) {
      localStorageClient.remove(STORAGE_KEYS.USER_ID);
    } else {
      localStorageClient.set(STORAGE_KEYS.USER_ID, value);
    }
  };

  // 識別ID更新
  const updateIdentifyId = (value) => {
    setIdentifyId(value);

    if (value === null || value === undefined) {
      localStorageClient.remove(STORAGE_KEYS.IDENTIFY_ID);
    } else {
      localStorageClient.set(STORAGE_KEYS.IDENTIFY_ID, value);
    }
  };

  // 権限ID更新
  const updateRoleId = (value) => {
    setRoleId(value);

    if (value === null || value === undefined) {
      localStorageClient.remove(STORAGE_KEYS.ROLE_ID);
    } else {
      localStorageClient.set(STORAGE_KEYS.ROLE_ID, value);
    }
  };

  /*
  課題・障害番号: IH-BUG-106
  対応日: 2026/03/24
  担当者: ユリヤ
  修正概要: ヘッダの企業クリニック名が表示されるのにタイムラグがある問題の修正
  */
  const updateCompanyName = (value) => {
    if (value === null || value === undefined) {
      localStorageClient.remove(STORAGE_KEYS.COMPANY_NAME);
    } else {
      localStorageClient.set(STORAGE_KEYS.COMPANY_NAME, value);
    }
    setCompanyName(value);
  };

  const updateKenpoName = (value) => {
    if (value === null || value === undefined) {
      localStorageClient.remove(STORAGE_KEYS.KENPO_NAME);
    } else {
      localStorageClient.set(STORAGE_KEYS.KENPO_NAME, value);
    }
    setKenpoName(value);
  };
  /*
  END
  課題・障害番号: IH-BUG-106
  */

  // 権限判定
  const isSystemManagement = auth === "0";
  const isAdmin = auth === "1" || auth === "2" || auth === "3";
  const isUsers = auth === "4";

  // ユーザーエージェントからモバイル系かどうかを判定
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const path = window.location.pathname.split("/");
  const isEmployeeNativeApp = path.includes("EmployeeNativeApp");

  return (
    <AuthContext.Provider
      value={{
        isLogin,
        isChecking,
        userId,
        identifyId,
        roleId,
        auth,
        isSystemManagement,
        isAdmin,
        isUsers,
        updateAuth,
        updateUserId,
        updateIdentifyId,
        updateRoleId,
        isMobile,
        isEmployeeNativeApp,
        /*
        課題・障害番号: KOSHO-77
        対応日: 2026/3/20
        担当者: 影山
        修正概要: Context内のログイン成功フラグを明示的に立てる処理（loginComplete）の追加
        */
        loginComplete,
        /*
        END
        課題・障害番号: KOSHO-77
        */

        /*
        課題・障害番号: IH-BUG-106
        対応日: 2026/03/24
        担当者: ユリヤ
        修正概要: ヘッダの企業クリニック名が表示されるのにタイムラグがある問題の修正
        */
        companyName,
        kenpoName,
        updateCompanyName,
        updateKenpoName,
        /*
        END
        課題・障害番号: IH-BUG-106
        */
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
